import React from 'react';
import CustomTheme from '../../../../../utilities/theme/theme.json';
import { Box, Card, Grid, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { getAllAuthUsersRequest } from '../../../../authentication/AuthenticationApiActions'
const UserlandingPage = ({ setShowNewUserForm, setAddNewUser }) => {

    return (
        <Box>
            <Grid container>
                <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
                    <Card className="blank-screen-new-team">
                        <Grid className="for-margin-top">
                            <Box className="info-blank-page">
                                <Typography style={{ color: CustomTheme.fontColor }}
                                    className="welcome-title">Let's begin by creating a new
                                    user</Typography>
                            </Box>
                            <Box className="info-blank-page">
                                <Button size="small"
                                    variant="outlined"
                                    color="primary"
                                    onClick={() => {
                                        setShowNewUserForm(true)
                                        setAddNewUser(true)
                                    }} className="blank-page-button-tasklist"><i
                                        className="fas fa-users"></i> <span
                                            className="btn-margin-left">+ User</span></Button>
                            </Box>
                        </Grid>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    )
}

const mapStateToProps = (state) => {
    return {
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
       
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UserlandingPage);
